// http://172.30.5.16/intranet/api
export const API_PATH = window.env.REACT_APP_API_ENDPOINT;
export const APP_PATH = window.env.REACT_APP_BASE_PATH;
export const ssoUrl = `https://sso2.assystem.com/cas/login?service=${encodeURIComponent(`${APP_PATH}/login/cas`)}`;
